module.exports = __webpack_public_path__ + "static/media/dashindicator.edd3d94a.png";